'use client';
/** @jsxImportSource @emotion/react */

import { type FC } from 'react';

import type { CollapseProps as MuiCollapseProps } from '@mui/material/Collapse';

import MuiCollapse from '@mui/material/Collapse';

/**
 * The Collapse component uses transitions and animations that depend on specific DOM properties (e.g., height, padding)
 * typically available on block-level elements like `div`. Using `span`, which is an inline element, can break this behavior.
 * And the default implementation in MUI is also broken, and altering it could lead to issues.
 *
 * https://serko.atlassian.net/browse/ZDS-1034
 */
type ExcludedMuiProps = 'component';

export type CollapseProps = Omit<MuiCollapseProps, ExcludedMuiProps>;

export const Collapse: FC<CollapseProps> = MuiCollapse;

Collapse.displayName = 'Collapse';
